// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__FEhco","error":"Textarea_error__3-Ypf","readonly":"Textarea_readonly__1v3r7","disabled":"Textarea_disabled__24c-9"};